import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("parentToken");
  const studentId = localStorage.getItem("selectedStudentId");
  const student = sessionStorage.getItem("student");

  // Authenticated if we have a token AND a selected student
  // OR if we still have the legacy student object in sessionStorage
  const isAuthenticated = (token && studentId) || !!student;

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;

